export const APP_HEADER_CONSTANT = {
    INIT_HEADER: 'INIT_HEADER',
    SHOW_OUTLOOK_MENU: 'SHOW_OUTLOOK_MENU',
    HIDE_OUTLOOK_MENU: 'HIDE_OUTLOOK_MENU'
};